<template>
  <transition name="modal-fade">
    <div @click="close()" class="modal-backdrop">
      <div @click.stop="" class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">
            <img width="120" src="../../assets/logo-essi-expert.svg" />
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <p>Votre Message a été envoyé.</p>
            <div @click="close()" class="btn-valid">Ok</div>
          </slot>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PopupValid',
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  height: 15vh;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 3px solid #0088ec;
  background-color: white;
  font-size: 16px;
  resize: none;
  margin-bottom: 2%;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
h3 {
  font-weight: bolder;
  text-align: left;
  margin-bottom: 2%;
  white-space: nowrap;
}
li:before {
  content: '- ';
}
.modal-backdrop {
  z-index: 2000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  border: solid 2px #0088ec;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.modal-header {
  display: flex;
  margin-top: 8%;
}
.modal-header h2 {
  padding-top: 40px;
  font-size: 20px;
}

.modal-body {
  height: 100%;
  width: 100%;
  padding: 8% 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.btn-valid {
  outline: none;
  cursor: pointer;
  color: white;
  background: #0088ec;
  padding: 4px 20%;
  margin: 0 auto;
  border-radius: 4px;
  font-size: 20px;
  white-space: nowrap;
}
p {
  font-size: 20px;
  white-space: nowrap;
  padding: 0;
  margin: 0 0 10%;
}
</style>
